import { AtRiskStatus } from '@weave/schema-gen-ts/dist/schemas/analytics-reporting/analytics_gateway/analytics_gateway.pb';
import { CheckListFilterSelector, FilterTraySection } from '@frontend/analytics-shared';
import { useTranslation } from '@frontend/i18n';
import { trackingIds } from '../../tracking-ids';
import { AppointmentNoShowRiskChip } from '../atoms/appointment-status-chips';

const statusOptions = {
  [AtRiskStatus.AT_RISK_STATUS_REPEAT_CANCEL]: (
    <AppointmentNoShowRiskChip status={AtRiskStatus.AT_RISK_STATUS_REPEAT_CANCEL} />
  ),
  [AtRiskStatus.AT_RISK_STATUS_REPEAT_NSR]: (
    <AppointmentNoShowRiskChip status={AtRiskStatus.AT_RISK_STATUS_REPEAT_NSR} />
  ),
};
interface AppointmentNoShowRiskTrayFilterProps {
  value?: AtRiskStatus[];
  onChange: (status?: AtRiskStatus[]) => void;
}

export const AppointmentNoShowRiskTrayFilter = ({ value, onChange }: AppointmentNoShowRiskTrayFilterProps) => {
  const { t } = useTranslation('analytics');

  return (
    <FilterTraySection
      label={t('No-Show Risk Status')}
      onReset={() => onChange(undefined)}
      disableReset={!value || value.length === 0}
    >
      <CheckListFilterSelector
        options={statusOptions}
        label={t('No-Show Risk Status')}
        onChange={(statuses) => {
          onChange(statuses.length === 0 ? undefined : (statuses as AtRiskStatus[]));
        }}
        value={value || []}
        showLabel={false}
        trackingIdBase={`${trackingIds.filterTrayToggle}-no-show-risk`}
      />
    </FilterTraySection>
  );
};
